<template>
  <div class="infos-logged">
    <template v-show="userLogged">
      <h2 class="checkout-h2" v-if="userName">Olá, {{ userName }}!</h2>
      <h2 class="checkout-h2">Você entrou com o email:</h2>
      <strong>
        <h4 class="checkout-h4 primary--text">{{ userProps.email }}</h4>
      </strong>
    </template>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import jwtDecode from 'jwt-decode';

export default {
  methods: {
    ...mapActions({
      logout: 'logout',
      setSignSteps: 'setSignSteps',
    }),
  },
  computed: {
    ...mapGetters({
      clientToken: 'clientToken',
      userProps: 'userProps',
    }),
    userName () {
      if (this.userProps && this.userProps.name) return this.userProps.name.split(' ')[0]
      else return ''
    },
    userLogged() {
      if (this.clientToken) {
        return jwtDecode(this.clientToken);
      }
      return false;
    },
  },
  mounted() {
    if (!this.getLS('clientToken') && !this.userLogged) {
      this.setSignSteps({ logged: false, signForm: true, step: 0 });
    }
  },
};
</script>
